module.exports = __webpack_public_path__ + "assets/img/cnt_top_logo.98171300.png";